import { useEffect, useState } from 'react';
import { useAuth } from '@/lib/auth';
import { CheckoutFormNonRegistration } from './CheckoutFormNonRegistration';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { CreditCard } from '@/features/auth/types';
import { BackNav } from '@/components/BackNavigation/BackNavigation';
import { PaymentCard } from './PaymentCard';
import { AppointmentData, Business } from '../types';
import './CreditCardNonRegistration.scss';
import Utils from '@/utils/util';
import { SquareForm } from './SquareForm';
import { useTranslation } from 'react-i18next';
type Props = {
  appointmentData?: AppointmentData;
  onSuccess: (data: AppointmentData) => void;
  onBackClick?: () => void;
  isLoading: boolean;
  hideBackNav?: boolean;
  paymentMode: string;
  locationId?:any;
};
export const CreditCardNonRegistration = ({
  onSuccess,
  onBackClick,
  isLoading,
  appointmentData,
  hideBackNav,
  paymentMode,
  locationId
}: Props) => {
  const { t } = useTranslation();
  const onPaymentMethodCreate = (paymentCard: CreditCard) => {
    onSuccess({ ...appointmentData, paymentCard: paymentCard });
  };
  const stripeKey = paymentMode === 'sandbox' ?  process.env.REACT_APP_STRIPE_KEY_SANDBOX : process.env.REACT_APP_STRIPE_KEY;
  const stripePromise = loadStripe(stripeKey as string);
  const [isAddNewCard, setAddNewCard] = useState<boolean>(false);
  const [defaultCreditCard, setDefaultCreditCard] = useState<CreditCard>();
  const [cardList, setCardList] = useState<CreditCard[]>();
  useEffect(() => {
    Utils.scrollToTop();
    if (appointmentData?.paymentCard) {
      setCardList([appointmentData.paymentCard]);
      setDefaultCreditCard(appointmentData.paymentCard);
      setAddNewCard(false);
    } else {
      setAddNewCard(true);
    }
  }, []);

  const onSelectAddCard = () => {
    setAddNewCard(true);
  };
  const onBackArrowClick = () => {
    if (isAddNewCard && appointmentData?.paymentCard) {
      setAddNewCard(false);
      setDefaultCreditCard(appointmentData.paymentCard);
    } else {
      onBackClick && onBackClick();
    }
  };
  const onCardSelect = (card: CreditCard) => {
    setDefaultCreditCard(card);
  };
  const onContinue = () => {
    if (appointmentData && defaultCreditCard) {
      appointmentData.paymentCard = defaultCreditCard;
      appointmentData && onSuccess({...appointmentData});
    }
  };

  const addSquareCardDetails = async (token: string, verificationToken: string | undefined,card: any) => {
    onSuccess({ ...appointmentData, paymentCard :card });
    //setAddNewCard(false);
  }
  return (
    <div className="card-details">
      {(!hideBackNav || (isAddNewCard && appointmentData?.paymentCard) )&& <BackNav onClick={onBackArrowClick} />}
      <div className="profile-container">

        <div className={`${isAddNewCard ? '' : 'height-unset'}`}>
          <div className="header">
            <h5>{!isAddNewCard ? t('Select billing card') : t('Add card')}</h5>
            <span onClick={onSelectAddCard}>{isAddNewCard ? '' : t('+ Add new')}</span>
          </div>{' '}
          <div className='bottom-section-card'>
            <div className="form-field personal">
              <label className="form-label">
                {isAddNewCard ? t('Add your card details below') : t('Choose a card to pay with')}
              </label>
              {isAddNewCard ? (
                 <>
                 {
              appointmentData?.business?.isStripeAccountVerified ? (
               
                <Elements stripe={stripePromise}>
                <CheckoutFormNonRegistration
                  onSuccess={onPaymentMethodCreate}
                />
              </Elements>
              ) : (
                <SquareForm
                  onSuccess={(token, verificationToken,card) =>{addSquareCardDetails(token, verificationToken,card)}}
                  onError={(err) => {
                    //showNotification({ type: 'error', title: err.message });
                  }}
                  saveCard={appointmentData?.selectedLocation?.registrationRequired === true ? true : false}
                  locationId={appointmentData?.business?.squareLocationId || ''}
                  businessLocationId = {locationId}
                />
              )
            }
                </>
              ) : (
                <>
                  <div className="card-list">
                    {cardList?.map((cl, index) => (
                      <PaymentCard
                        key={`payment-card${index}`}
                        data={cl}
                        isSelected={
                          defaultCreditCard && cl.id == defaultCreditCard.id ? true : false
                        }
                        onSelect={onCardSelect}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {!isAddNewCard && (
          <div className={`action ${isAddNewCard ? '' : 'height-unset'}`}>
            <button className="petsked-button button-dark" onClick={onContinue}>
              {t('Continue')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
